import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { IncidenciaUsuarioCategoriaService } from '../../../../src/app/shared/services';
import { MenuFuncionService } from '../../../../src/app/shared/services/menuFuncion.service';

import { MenuFuncionCodes, IncidenciaUsuarioCategoria, SaveIncidenciaUsuarioCategoriaDto, SearchIncidenciaUsuarioCategoriaRequest, DialogConfirmRequest, DialogConfirmResponse, IncidenciaUsuarioCategoriaCustomDto } from '../../../../src/app/shared/model';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { GridComponent } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-incidenciaUsuarioCategoriaEdit',
  templateUrl: './incidenciaUsuarioCategoriaEdit.component.html',
  styleUrls: ['./incidenciaUsuarioCategoriaEdit.component.scss']

})

export class IncidenciaUsuarioCategoriaEditComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;
  formGroup: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoSearching: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;

  msgError: string = "";
  item: IncidenciaUsuarioCategoria;
  incidenciaCategoriaList: IncidenciaUsuarioCategoria[];
  filteredCategoriaList: IncidenciaUsuarioCategoria[];
  isCategoriaSearching: boolean = false;
  incidenciaUsuarioCategoriaCustomList: IncidenciaUsuarioCategoriaCustomDto[] = [];

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private incidenciaUsuarioCategoriaService: IncidenciaUsuarioCategoriaService) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.INCIDENCIA_USUARIO_CATEGORIA).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_CATEGORIA_EDIT);
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_CATEGORIA_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_CATEGORIA_LIST);
        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_CATEGORIA_DELETE);
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.getCategorias();
    this.loadEntity();
  }

  getCategorias(){
    let r = new SearchIncidenciaUsuarioCategoriaRequest(null,null,null,null,null,null,null, null);
    this.isCategoriaSearching = true;
    this.incidenciaUsuarioCategoriaService.search(r).subscribe((data)=>{
      if (data != null) {
        this.incidenciaCategoriaList = data.result;
        this.filteredCategoriaList = this.incidenciaCategoriaList;
        this.isCategoriaSearching = false;
      }
    },
    (err: HttpErrorResponse) =>{
      this.isCategoriaSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(200)]],
      'Codigo': [null, [Validators.required, Validators.maxLength(100)]],
      'CategoriaPadreId': [null],
      'Activo': [true, Validators.required]
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
            if(this.canView || this.canEdit){
              this.isSearching = true;
              this.incidenciaUsuarioCategoriaService.get(id).subscribe(data => {
                this.isSearching = false;
                if (data != null && data.Success) {
                  this.item = data.Result;

                  if (this.item != null && this.item.Id > 0) {
                    this.incidenciaUsuarioCategoriaCustomList = this.item.IncidenciaUsuarioCategoriaCustoms;
                    this.formGroup.patchValue(this.item);
                    this.formGroup.get("CategoriaPadreId")?.setValue(this.incidenciaCategoriaList.find(x => x.Id == this.item.CategoriaPadreId));
                    this.grid?.refresh();
                  }
                  else
                    this.msgError = "No se encontró el item seleccionado.";
                }
                else
                  this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
              },
              (err: HttpErrorResponse) => {
                this.isSearching = false;
                this.sharedFunctions.handleError(err, true);
              })
            }else{
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.onCancel();
            }
        }
        else
          this.msgError = "Item no válido.";
      }
      else
      {
        if (this.canAdd){
          this.item = new IncidenciaUsuarioCategoria(0, null, null, null, false, false, true, []);
          this.formGroup.patchValue(this.item);
        }else{
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
      }
    });
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  displayCategoria(categoria: IncidenciaUsuarioCategoria): string {
    return categoria && categoria.Nombre ? categoria.Nombre + " | " + categoria.Codigo : '';
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveIncidenciaUsuarioCategoriaDto(null, null, null, null, null, true, []);
    if(this.incidenciaUsuarioCategoriaCustomList?.length > 0)
      r.IncidenciaUsuarioCategoriaCustomDtos = this.incidenciaUsuarioCategoriaCustomList;

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        MostrarEnDashBoard: this.item.MostrarEnDashBoard,
        CodigoRequerido: this.item.CodigoRequerido,
        Activo: this.item.Activo,
        CategoriaPadreId: this.formGroup.value.CategoriaPadreId?.Id,
        IncidenciaUsuarioCategoriaCustomDtos: this.incidenciaUsuarioCategoriaCustomList
      }
    };

    this.isSaving = true;
    this.incidenciaUsuarioCategoriaService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  onDelete() {
    if (!this.canDelete)
        return false;
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar la categoria de incidencia?", null, null)
    });
    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
            this.isDeleting = true;
            this.incidenciaUsuarioCategoriaService.delete(this.item.Id).subscribe(data => {
                this.isDeleting = false;
                if (data != null && data.Success && data.Result) {
                    this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
                    this.onCancel();
                }
                else
                    this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
            },
            (err: HttpErrorResponse) => {
                this.isDeleting = false;
                this.sharedFunctions.handleError(err, true);
            })
        }
    });
  }

  onNuevoCampo(){
    this.incidenciaUsuarioCategoriaCustomList.push(new IncidenciaUsuarioCategoriaCustomDto(0, "'Campo nuevo'", "", this.item.Id, true, true));
    this.grid?.refresh();
  }

  onNuevoCampoChange(rowIndex: number, pedidoItemId: number, event: any) {
    if (rowIndex >= 0) {
      var controlName = event?.target?.name;
      var controlValue = event?.target?.value;

      switch (controlName) {
        case "NombreCampo":
          this.incidenciaUsuarioCategoriaCustomList[rowIndex].NombreCampo = controlValue;
          break;
        case "TipoDato":
          this.incidenciaUsuarioCategoriaCustomList[rowIndex].TipoDato = controlValue;
          break;
        case "Requerido":
          this.incidenciaUsuarioCategoriaCustomList[rowIndex].Requerido = event?.target?.checked;
          break;
        case "Activo":
          this.incidenciaUsuarioCategoriaCustomList[rowIndex].Activo = event?.target?.checked;
          break;
      }
    }
  }

  onNuevoCampoDelete(rowIndex: number) {
    this.incidenciaUsuarioCategoriaCustomList = this.incidenciaUsuarioCategoriaCustomList.filter(item => item !== this.incidenciaUsuarioCategoriaCustomList[rowIndex]);
  }

  onGridActionFailure(event: any): void {
    // this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda errror", "Error");
    // console.log(event)
  }

  filterCategoriaList(value){
    const filterValue = value.toLowerCase();
    this.filteredCategoriaList = this.incidenciaCategoriaList.filter(x =>
      x.Nombre?.toLowerCase().includes(filterValue) ||
      x.Codigo?.toLowerCase().includes(filterValue));
  }
}
